import { useEffect, useState } from 'react';

const API_BASE = process.env.NODE_ENV === 'production'
  ? ''
  : 'http://localhost:3001';

interface AuthUser {
  id: string;
  email: string;
  name: string;
  avatar: string | null;
}

interface AuthState {
  authenticated: boolean;
  loading: boolean;
  user: AuthUser | null;
  authError: boolean;
}

export const useAuth = (): AuthState => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<AuthUser | null>(null);

  const authError = new URLSearchParams(window.location.search).has('auth_error');

  useEffect(() => {
    fetch(`${API_BASE}/auth/me`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        setAuthenticated(data.authenticated);
        setUser(data.user);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return { authenticated, loading, user, authError };
};
